import { TCallbackFn } from '@src/models/common';
import { useCallback, useEffect, useRef } from 'react';

/** Хук обертка сохраняет передаваемую функцию и возвращает ссылку на нее.
 * @param fn - функция
 * @returns ссылка на функцию
 *
 * @example
 * const eventCallback = useEventCallback(cb);
 */
export const useEventCallback = <A extends unknown[], R>(fn: TCallbackFn<A, R>): TCallbackFn<A, R> => {
  const ref = useRef(fn);

  useEffect(() => {
    ref.current = fn;
  });

  return useCallback((...args: A): R => ref.current?.(...args), []);
};
